import React, { useEffect } from "react";
// import Image from "../../assets/bgimg.png";
import AOS from 'aos';
import "aos/dist/aos.css";

import Fade from 'react-reveal/Fade';
import Tokenomics from '../../site/content/tokenomics.json'
import "./features.css";
import About from '../../site/content/how.json'
import Image from "../../Pyragon/Website Assets/Features Section/Screen Shot 2021-06-17 at 1.16.36 PM.png";

import Image1 from "../../Pyragon/Website Assets/Features Section/RFI.png";
import Image2 from "../../Pyragon/Website Assets/Features Section/Automatic LP.png";
import Image3 from "../../Pyragon/Website Assets/Features Section/earn.png";
import Image4 from "../../Pyragon/Website Assets/Features Section/deflationary.png";

const Features = () => {
    useEffect(()=>{
        AOS.init();
    } , []);

  return (
    <div id="features">
      <Fade>
      <h1 className="work-heading">FEATURES</h1>
      </Fade>
      <div className="token feature">
        <div className="token-img">
            <img src={Image1} alt="Image"/>
        </div>
        <div className="token-img">
            <img src={Image2} alt="Image"/>
        </div>
      </div>
      <div className="token feature token02">
        <div className="token-img">
            <img src={Image3} alt="Image"/>
        </div>
        <div className="token-img">
            <img src={Image4} alt="Image"/>
        </div>
      </div>
    </div>
  );
};

export default Features;
